import React from 'react';
import PageHeader from '../components/PageHeader';
import Services from '../components/ServiceCard';
import Testimonial from '../components/Testimonial';
// import Services from '../components/Services';

const Service = () => {
    return (
        <>
            <PageHeader
                title="Our Services"
                image="img/subscribe-img.jpg" // Use your own path
                breadcrumbs={[
                    { label: "Services", active: true },
                ]}
            />
            <Services />
            {/* <Testimonial /> */}
        </>
    );
};

export default Service;
